(function () {
  'use strict';

  var cfg = window.trackingConfig || {};
  var strings = cfg.strings || {};
  var workerUrl = (cfg.workerUrl || '').replace(/\/$/, '');
  var sectionId = cfg.sectionId || '';

  if (!sectionId) return;

  var tabsEl      = document.getElementById('tracking-tabs-'          + sectionId);
  var orderForm   = document.getElementById('tracking-order-form-'    + sectionId);
  var form        = document.getElementById('tracking-form-'          + sectionId);
  var loading     = document.getElementById('tracking-loading-'       + sectionId);
  var results     = document.getElementById('tracking-results-'       + sectionId);
  var errorEl     = document.getElementById('tracking-error-'         + sectionId);
  var errorMsg    = document.getElementById('tracking-error-msg-'     + sectionId);
  var statusBadge = document.getElementById('tracking-status-badge-'  + sectionId);
  var numDisplay  = document.getElementById('tracking-number-display-' + sectionId);
  var metaEl      = document.getElementById('tracking-meta-'          + sectionId);
  var stepperEl   = document.getElementById('tracking-stepper-'       + sectionId);
  var eventsEl    = document.getElementById('tracking-events-'        + sectionId);

  if (!orderForm && !form) return;

  /* Visibility helpers */
  function showOnly(el) {
    [loading, results, errorEl].forEach(function (e) { if (e) e.hidden = true; });
    if (el) el.hidden = false;
  }

  /* Status codes */
  var STATUS = {
    '-1': { key: 'pending',     label: strings.status_pending     || 'Pending'      },
    '0':  { key: 'not_found',   label: strings.status_not_found   || 'Not Found'    },
    '10': { key: 'in_transit',  label: strings.status_in_transit  || 'In Transit'   },
    '20': { key: 'expired',     label: strings.status_expired     || 'Expired'      },
    '30': { key: 'delivered',   label: strings.status_delivered   || 'Delivered'    },
    '35': { key: 'undelivered', label: strings.status_undelivered || 'Undelivered'  },
    '40': { key: 'exception',   label: strings.status_exception   || 'Alert'        },
    '50': { key: 'expired',     label: strings.status_expired     || 'Expired'      }
  };

  function getStatus(code) {
    return STATUS[String(code)] || STATUS['-1'];
  }

  /* Country flag emoji */
  function countryFlag(code) {
    if (!code || code.length !== 2) return '';
    try {
      var chars = code.toUpperCase().split('').map(function (c) {
        return 127397 + c.charCodeAt(0);
      });
      return String.fromCodePoint.apply(String, chars);
    } catch (e) {
      return code.toUpperCase();
    }
  }

  /* Date formatting */
  function formatDate(str) {
    if (!str) return { day: '', time: '' };
    var d = new Date((str + '').replace(' ', 'T'));
    if (isNaN(d.getTime())) return { day: str, time: '' };
    var locale = (cfg.locale || window.shopLocale || 'en').replace('_', '-');
    return {
      day:  d.toLocaleDateString(locale,  { month: 'short', day: 'numeric', year: 'numeric' }),
      time: d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
    };
  }

  /* HTML escape */
  function esc(s) {
    return (s == null ? '' : String(s))
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  var pageLocale  = (cfg.locale || window.shopLocale || 'en').replace('_', '-').split('-')[0].toLowerCase();
  var hideChina   = cfg.hideChina === true;

  /* Render status badge */
  function renderStatus(code) {
    var s = getStatus(code);
    statusBadge.className = 'tracking-status-badge tracking-status-badge--' + s.key;
    statusBadge.textContent = s.label;
  }

  /* Render meta card */
  function renderMeta(data) {
    if (!metaEl) return;
    var html = '';
    if (data.carrier) {
      html += '<div class="tracking-meta-item">'
        + '<span class="tracking-meta-item__label">' + esc(strings.carrier_label || 'Carrier') + '</span>'
        + '<span class="tracking-meta-item__value">'  + esc(data.carrier) + '</span>'
        + '</div>';
    }
    if (data.origin || data.destination) {
      html += '<div class="tracking-meta-item">'
        + '<span class="tracking-meta-item__label">' + esc(strings.from_label || 'Route') + '</span>'
        + '<span class="tracking-meta-route">';
      if (data.origin)      html += '<span>' + countryFlag(data.origin) + '&nbsp;' + esc(data.origin) + '</span>';
      if (data.origin && data.destination) html += '<span class="tracking-meta-route__arrow">&#8594;</span>';
      if (data.destination) html += '<span>' + countryFlag(data.destination) + '&nbsp;' + esc(data.destination) + '</span>';
      html += '</span></div>';
    }
    if (data.lastEvent && data.lastEvent.date) {
      var fmt = formatDate(data.lastEvent.date);
      html += '<div class="tracking-meta-item">'
        + '<span class="tracking-meta-item__label">' + esc(strings.last_update || 'Last Update') + '</span>'
        + '<span class="tracking-meta-item__value">'
        + esc(fmt.day) + (fmt.time ? ' &middot; ' + esc(fmt.time) : '')
        + '</span></div>';
    }
    metaEl.innerHTML = html;
  }

  /* Milestone stepper */
  var STEPS = [
    { strKey: 'step_info_received'    },
    { strKey: 'step_shipped'          },
    { strKey: 'step_in_transit'       },
    { strKey: 'step_out_for_delivery' },
    { strKey: 'step_delivered'        }
  ];

  function getStepIndex(statusCode, events) {
    var code = Number(statusCode);
    if (code === 30) return 4;
    if (code === 35 || code === 40) return 3;
    if (code === 10) {
      for (var i = 0; i < events.length; i++) {
        var s = events[i].stage;
        if (s === 'OutForDelivery' || s === 'AvailableForPickup') return 3;
        if (s) break;
      }
      return 2;
    }
    if (events.length > 0) return 1;
    return 0;
  }

  function buildStepper(statusCode, events) {
    if (!stepperEl) return;
    var currentIndex = getStepIndex(statusCode, events);
    var isException  = (Number(statusCode) === 40 || Number(statusCode) === 35);
    var fillPct      = Math.round(currentIndex / (STEPS.length - 1) * 100);

    var html = '<div class="tracking-stepper__inner">'
      + '<div class="tracking-stepper__line-bg"></div>'
      + '<div class="tracking-stepper__line-fill" style="width:' + fillPct + '%"></div>';

    for (var i = 0; i < STEPS.length; i++) {
      var isPast    = i < currentIndex;
      var isCurrent = i === currentIndex;
      var isFirst   = i === 0;
      var label     = strings[STEPS[i].strKey] || '';
      var dotCls    = 'tracking-stepper__dot'
        + (isPast    ? ' tracking-stepper__dot--past'    : '')
        + (isCurrent ? ' tracking-stepper__dot--current' : '')
        + (isCurrent && isException ? ' tracking-stepper__dot--exception' : '');

      html += '<div class="tracking-stepper__step' + (isFirst ? ' tracking-stepper__step--first' : '') + '">'
        + '<div class="' + dotCls + '">'
        + (isCurrent && !isException ? '<div class="tracking-stepper__pulse"></div>' : '')
        + '</div>'
        + '<span class="tracking-stepper__label'
        + (isCurrent ? ' tracking-stepper__label--current' : '') + '">'
        + esc(label) + '</span>'
        + '</div>';
    }

    html += '</div>';
    stepperEl.innerHTML = html;
    stepperEl.hidden = false;
  }

  /* Render timeline */
  var TIMELINE_LIMIT = 8;

  function buildEventHtml(e, first) {
    var fmt = formatDate(e.date);

    var displayCountry  = e.country;
    var displayLocation = e.location;
    var showFlag        = true;
    if (hideChina && e.country === 'CN') {
      displayCountry  = '';
      displayLocation = 'Warehouse';
      showFlag        = false;
    }

    var html = '<div class="tracking-event' + (first ? ' tracking-event--first' : '') + '">';
    html += '<div class="tracking-event__date">'
      + '<span class="tracking-event__date-day">'  + esc(fmt.day)  + '</span>'
      + '<span class="tracking-event__date-time">' + esc(fmt.time) + '</span>'
      + '</div>';
    html += '<div class="tracking-event__spine">'
      + '<div class="tracking-event__dot"></div>'
      + '<div class="tracking-event__line"></div>'
      + '</div>';
    html += '<div class="tracking-event__content">';
    if (e.description) {
      html += '<p class="tracking-event__desc">' + esc(e.description) + '</p>';
    }
    if (displayLocation || displayCountry) {
      html += '<p class="tracking-event__location">'
        + (showFlag && displayCountry ? countryFlag(displayCountry) + ' ' : '')
        + esc(displayLocation || displayCountry)
        + '</p>';
    }
    html += '</div></div>';
    return html;
  }

  function renderTimeline(events) {
    if (!events || !events.length) return;

    var visible = events.slice(0, TIMELINE_LIMIT);
    var hidden  = events.slice(TIMELINE_LIMIT);

    var html = '';
    for (var i = 0; i < visible.length; i++) {
      html += buildEventHtml(visible[i], i === 0);
    }

    if (hidden.length > 0) {
      html += '<button type="button" class="tracking-show-more">'
        + esc(strings.show_more || 'Show more')
        + ' (' + hidden.length + ')'
        + '</button>';
    }

    eventsEl.innerHTML = html;

    if (hidden.length > 0) {
      eventsEl.querySelector('.tracking-show-more').addEventListener('click', function () {
        var btn = this;
        var extra = '';
        for (var j = 0; j < hidden.length; j++) {
          extra += buildEventHtml(hidden[j], false);
        }
        btn.insertAdjacentHTML('beforebegin', extra);
        btn.remove();
      });
    }
  }

  /* Tab switching */
  function switchTab(tab) {
    if (tabsEl) {
      tabsEl.querySelectorAll('.tracking-tab').forEach(function (t) {
        t.classList.toggle('tracking-tab--active', t.dataset.tab === tab);
      });
    }
    if (orderForm) orderForm.hidden = (tab !== 'order');
    if (form)      form.hidden      = (tab !== 'tracking');
    showOnly(null);
  }

  if (tabsEl) {
    tabsEl.addEventListener('click', function (e) {
      var tab = e.target.closest('.tracking-tab');
      if (tab) switchTab(tab.dataset.tab);
    });
  }

  /* Copy-to-clipboard button next to tracking number */
  function attachCopyBtn(text) {
    var container = numDisplay ? numDisplay.parentNode : null;
    if (!container) return;

    var existing = container.querySelector('.tracking-copy-btn');
    if (existing) existing.remove();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tracking-copy-btn';
    btn.setAttribute('aria-label', strings.copied || 'Copied!');
    btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"'
      + ' stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"/>'
      + '<path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/>'
      + '</svg>'
      + '<span class="tracking-copy-tooltip">' + esc(strings.copied || 'Copied!') + '</span>';

    btn.addEventListener('click', function () {
      var self = this;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function () {});
      } else {
        try {
          var ta = document.createElement('textarea');
          ta.value = text;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        } catch (_) {}
      }
      self.classList.add('tracking-copy-btn--done');
      setTimeout(function () { self.classList.remove('tracking-copy-btn--done'); }, 1500);
    });

    numDisplay.insertAdjacentElement('afterend', btn);
  }

  /* Shared render after data received */
  function renderTrackingData(data, label) {
    var upperLabel = (label || '').toUpperCase();
    if (numDisplay) numDisplay.textContent = upperLabel;
    attachCopyBtn(upperLabel);
    renderStatus(data.statusCode);
    renderMeta(data);
    buildStepper(data.statusCode, data.events || []);
    renderTimeline(data.events || []);
    showOnly(results);
  }

  /* Shared error display */
  function showError(errorCode) {
    showOnly(errorEl);
    if (!errorMsg) return;
    if (errorCode === 'not_found') {
      errorMsg.textContent = strings.error_not_found || 'No tracking data found.';
    } else if (errorCode === 'pending') {
      errorMsg.textContent = strings.error_pending || 'Try again in a few minutes.';
    } else if (errorCode === 'order_not_found') {
      errorMsg.textContent = strings.error_order_not_found || 'No order found with this number and email.';
    } else if (errorCode === 'no_tracking') {
      errorMsg.textContent = strings.error_no_tracking || 'This order has no tracking information yet.';
    } else {
      errorMsg.textContent = strings.error_generic || 'An error occurred.';
    }
  }

  /* Track by tracking number */
  function track(number) {
    if (!workerUrl) { showError('generic'); return; }
    showOnly(loading);
    var langParam = pageLocale !== 'en' ? '&lang=' + encodeURIComponent(pageLocale) : '';
    fetch(workerUrl + '?number=' + encodeURIComponent(number) + langParam)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.error) { showError(data.error); return; }
        renderTrackingData(data, number);
      })
      .catch(function () { showError('generic'); });
  }

  /* Track by order number + email */
  function trackByOrder(order, email) {
    if (!workerUrl) { showError('generic'); return; }
    showOnly(loading);
    var langParam = pageLocale !== 'en' ? '&lang=' + encodeURIComponent(pageLocale) : '';
    fetch(workerUrl + '?order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email) + langParam)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.error) { showError(data.error); return; }
        renderTrackingData(data, data.trackingNumber || order);
      })
      .catch(function () { showError('generic'); });
  }

  /* Order form submit */
  if (orderForm) {
    orderForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var orderInput = document.getElementById('tracking-order-input-' + sectionId);
      var emailInput = document.getElementById('tracking-email-input-' + sectionId);
      var order = orderInput ? orderInput.value.trim() : '';
      var email = emailInput ? emailInput.value.trim() : '';
      if (!order || !email) return;
      trackByOrder(order, email);
    });
  }

  /* Tracking number form submit */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = document.getElementById('tracking-input-' + sectionId);
      var number = input ? input.value.trim() : '';
      if (!number) return;
      track(number);
    });
  }

  /* Auto-track from URL query params */
  try {
    var params = new URLSearchParams(window.location.search);
    var auto = params.get('number') || params.get('tracking');
    var autoOrder = params.get('order');
    var autoEmail = params.get('email');
    if (auto) {
      switchTab('tracking');
      var inp = document.getElementById('tracking-input-' + sectionId);
      if (inp) inp.value = auto;
      track(auto);
    } else if (autoOrder && autoEmail) {
      switchTab('order');
      var orderInp = document.getElementById('tracking-order-input-' + sectionId);
      var emailInp = document.getElementById('tracking-email-input-' + sectionId);
      if (orderInp) orderInp.value = autoOrder;
      if (emailInp) emailInp.value = autoEmail;
      trackByOrder(autoOrder, autoEmail);
    }
  } catch (e) { /* ignore */ }

})();
